document.addEventListener('DOMContentLoaded', () => {
  const headerSearchbar = document.querySelector('header-searchbar');
  let currentIndex = -1;

  headerSearchbar.inputElement.addEventListener('keydown', (e) => {
    const items = document.querySelectorAll('[data-suggestion-list] a');
    if (items.length > 0) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        currentIndex = (currentIndex + 1) % items.length;
        updateHighlight(items);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        currentIndex = (currentIndex - 1 + items.length) % items.length;
        updateHighlight(items);
      } else if (e.key === 'Enter') {
        if (currentIndex >= 0 && currentIndex < items.length) {
          e.preventDefault();
          items[currentIndex].click();
        }
      } else if (e.key === 'Escape') {
        e.preventDefault();
        currentIndex = -1;
        updateHighlight(items);
      }
    }
  }); 

  function updateHighlight(items) {
    items.forEach(item => item.classList.remove('highlighted'));
    if (currentIndex >= 0 && currentIndex < items.length) {
      items[currentIndex].classList.add('highlighted');
    }
  }

  headerSearchbar.inputElement.addEventListener("input", (e) => currentIndex = -1);
});